import { colors } from 'shared/styles/colors'
import styled, { css } from 'styled-components'

interface IContainerProps {
  type: 'warning' | 'error' | 'success' | 'info'
  backgroundColor?: string
}
export const Container = styled.div<IContainerProps>`
  display: flex;
  width: 100%;
  min-height: 50px;
  padding: 16px 24px;

  ${props =>
    props.type === 'success' &&
    css`
      background-color: ${colors.green};
    `}

  ${props =>
    props.type === 'warning' &&
    css`
      background-color: ${colors.warning};
    `}

  ${props =>
    props.type === 'error' &&
    css`
      background-color: ${colors.red};
    `}

  ${props =>
    props.type === 'info' &&
    css`
      background-color: ${colors.grayLight4};
    `}

    background-color: ${props => props.backgroundColor};
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`
